import React from 'react';
export default class Slice extends React.Component {
    constructor(props) {
        super(props);
    }
    getAnglePoint(startAngle, endAngle, radius, x, y) {
        const x1 = x + radius * Math.cos((Math.PI * startAngle) / 180);
        const y1 = y + radius * Math.sin((Math.PI * startAngle) / 180);
        const x2 = x + radius * Math.cos((Math.PI * endAngle) / 180);
        const y2 = y + radius * Math.sin((Math.PI * endAngle) / 180);
        return { x1, y1, x2, y2 };
    }
    render() {
        let p = this.props;
        let path = [];
        let a, b, c;
        // Get angle points
        a = this.getAnglePoint(p.startAngle, p.startAngle + p.angle, p.radius, p.radius, p.radius);
        b = this.getAnglePoint(p.startAngle, p.startAngle + p.angle, 0, p.radius, p.radius);
        path.push('M' + a.x1 + ',' + a.y1);
        path.push('A' + p.radius + ',' + p.radius + ' 0 ' + (p.angle > 180 ? 1 : 0) + ',1 ' + a.x2 + ',' + a.y2);
        path.push('L' + b.x2 + ',' + b.y2);
        path.push('A0,0 0 ' + (p.angle > 180 ? 1 : 0) + ',0 ' + b.x1 + ',' + b.y1);
        // Close
        path.push('Z');
        c = this.getAnglePoint(p.startAngle, p.startAngle + p.angle / 2, p.radius / 2, p.radius, p.radius);
        let x = c.x2;
        let y = c.y2;
        return (React.createElement("g", { overflow: "hidden" },
            React.createElement("path", { d: path.join(' '), fill: p.fill, stroke: p.stroke, strokeWidth: p.strokeWidth }),
            p.percentValue > 0 ? (React.createElement("text", { x: x, y: y, fill: "#fff", textAnchor: "middle" }, p.percentValue.toFixed(1) + '%')) : null));
    }
}
